import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ShareIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Share`} {...props}>
    <Path
      d="M5.66667 7H3.33333C2.59695 7 2 7.59695 2 8.33333V13.6667C2 14.403 2.59695 15 3.33333 15H12.6667C13.403 15 14 14.403 14 13.6667V8.33333C14 7.59695 13.403 7 12.6667 7H10.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <Path
      d="M8 2L8 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <Path
      d="M5 4L8 1L11 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
